import { getExamHeading } from '@/utils/get-exam-heading';
import { isStringEmpty } from '@monash/portal-frontend-common';
import { getClass } from './utils';

export const getTitle = (event, isForScreenReader = false) => {
  const { eventKind, eventType, data } = event;
  const unitCode = data?.unitCode;
  const unitCodeForScreenReader = isStringEmpty(unitCode)
    ? ''
    : unitCode.split('').join(' ');
  const unitCodeText = isForScreenReader ? unitCodeForScreenReader : unitCode;

  if (eventKind === 'assessment') {
    return `${unitCodeText}: ${data?.name}`;
  }

  if (eventType) {
    if (eventType === 'exam') {
      const formattedExamHeading = getExamHeading(data.activityType);

      return `${unitCodeText}: ${formattedExamHeading}`;
    } else {
      return `${unitCodeText}: ${getClass(event)}`;
    }
  }
};
